import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";

import Typography from "@material-ui/core/Typography";
import { withStyles } from "@material-ui/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";

import Accordion from "../Accordion";
import { useStyles } from "./styles";

import meta from "./meta";

const FAQ = ({ classes }) => {
  const { selectedNetwork } = useSelector(state => state.user);
  const [tabValue, setTabValue] = useState(0);
  const [tabs, setTabs] = useState(meta[selectedNetwork].tabs);

  let communityDetails = meta[selectedNetwork].communityDetails;

  const [selectedTab, setSelectedTab] = useState(tabs[0].data);

  const handleChange = (_event, newValue) => {
    const tab = tabs.find(tab => tab.value === newValue);

    setTabValue(newValue);
    setSelectedTab(tab.data);
  };

  useEffect(() => {
    const newTabs = meta[selectedNetwork].tabs;
    setTabs(newTabs);
    setSelectedTab(newTabs[0].data);
    setTabValue(0);
  }, [selectedNetwork]);

  const PageTitle = () => {
    return <Typography variant="h2">Frequently Asked Questions</Typography>;
  };

  const FAQTabs = () => {
    return (
      <AppBar position="static" className={classes.appBar}>
        <Tabs
          className={classes.tabs}
          value={tabValue}
          onChange={handleChange}
          variant="scrollable"
          indicatorColor="primary"
          textColor="primary"
          aria-label="scrollable force tabs example"
        >
          {tabs.map(tab => (
            <Tab
              key={tab.value}
              className={classes.tab}
              label={
                <p>
                  {tab.label} <span>FAQ</span>
                </p>
              }
              icon={<img src={tab.image} alt={tab.alt} />}
              value={tab.value}
            />
          ))}
        </Tabs>
      </AppBar>
    );
  };

  const FAQTab = () => {
    return (
      <div className={classes.accordionContainer}>
        <Accordion data={selectedTab} />
      </div>
    );
  };

  const CommunityContainer = () => {
    return (
      <div className={classes.learnAndShareContainer}>
        <Typography variant="h2">Learn and share in the community</Typography>
        <ul>
          {communityDetails.map(item => (
            <li key={item.title}>
              <a href={item.to} title={item.title} target="_blank" rel="noopener noreferrer">
                <img src={item.image} alt={item.title} />
                <Typography variant="h6">{item.title}</Typography>
                <Typography>{item.description}</Typography>
              </a>
            </li>
          ))}
        </ul>
      </div>
    );
  };

  return (
    <div className={classes.faqContainer}>
      <PageTitle />
      <FAQTabs />
      <FAQTab />
      <CommunityContainer />
    </div>
  );
};

export default withStyles(useStyles)(FAQ);
